// Particle rendering functions - パーティクル描画処理

import { getP5 } from '../../core/p5-instance';
import { getParticles, getBoosterParticles } from '../../store';

/**
 * drawParticles() - 全パーティクルの描画
 * 爆発パーティクルとブースターパーティクルを描画
 */
export function drawParticles() {
    const p = getP5();

    // 爆発パーティクル
    for (const particle of getParticles()) {
        // 寿命に応じて透明度を変化（maxLifeが設定されていればそれを使用）
        const maxLife = particle.maxLife || 40;
        const lifeRatio = particle.life / maxLife;

        if (particle.expand) {
            // expand: 球体が広がって中央からズレて消える（三日月状）
            let alpha: number;
            if (lifeRatio > 0.25) {
                alpha = 255;
            } else {
                alpha = p.map(lifeRatio, 0, 0.25, 0, 255);
            }

            // 火球をグラデーションで描画（外側オレンジ→内側白）
            p.noStroke();
            // 外側: オレンジ
            p.fill(255, 120, 0, alpha * 0.8);
            p.circle(particle.x, particle.y, particle.size);
            // 中間: 黄オレンジ
            p.fill(255, 180, 50, alpha * 0.9);
            p.circle(particle.x, particle.y, particle.size * 0.7);
            // 内側: 元の色（白っぽい）
            p.fill(p.red(particle.color), p.green(particle.color), p.blue(particle.color), alpha);
            p.circle(particle.x, particle.y, particle.size * 0.4);

            // ランダム方向からオフセットした円で消す（三日月状に）
            const eraseDelay = particle.eraseDelay ?? 0.2;
            const eraseProgress = 1 - lifeRatio; // 0→1に増加
            if (eraseProgress > eraseDelay) {
                const eraseSize = particle.size * (eraseProgress - eraseDelay) / (1 - eraseDelay) * 1.2;
                const randOffsetX = particle.targetX || 0;
                const randOffsetY = particle.targetY || 0;
                // eraseAngleで欠け方向を決定（未設定時は左上方向にフォールバック）
                const angle = particle.eraseAngle ?? (5 * Math.PI / 4);
                const baseOffsetX = p.cos(angle) * particle.size * 0.25 * eraseProgress;
                const baseOffsetY = p.sin(angle) * particle.size * 0.25 * eraseProgress;
                const offsetX = baseOffsetX + randOffsetX * eraseProgress;
                const offsetY = baseOffsetY + randOffsetY * eraseProgress;
                p.erase();
                p.circle(particle.x + offsetX, particle.y + offsetY, eraseSize);
                p.noErase();
            }
        } else {
            // 通常: 塗りつぶし円
            const alpha = p.map(particle.life, 0, maxLife, 0, 255);
            p.noStroke();
            p.fill(p.red(particle.color), p.green(particle.color), p.blue(particle.color), alpha);
            p.circle(particle.x, particle.y, particle.size);
        }
    }

    // ブースターパーティクル（ステージ開始演出時）
    p.noStroke();
    for (const bp of getBoosterParticles()) {
        const alpha = p.map(bp.life, 0, 30, 0, bp.alpha);
        p.fill(p.red(bp.color), p.green(bp.color), p.blue(bp.color), alpha);
        p.circle(bp.x, bp.y, bp.size);
    }
}
